import { z } from 'zod';
import { transformAndFilterValidItems } from '../../../common/tools/transformUtils';

export const RepresentativeSchema = z
    .object({
        id: z.string(),
        key: z.string(),
        name: z.string(),
        phone: z.string().nullable(),
        email: z.string().nullable(),
        salesAddressLine1: z.string().nullable(),
        salesAddressLine2: z.string().nullable(),
        salesAddressLine3: z.string().nullable(),
        countryOrSubnational: z.array(
            z.object({
                id: z.string(),
            })
        ),
        logo: z
            .object({
                fullpath: z.string(),
            })
            .nullable(),
        text: z.string().nullable(),
    })
    .describe('RepresentativeSchema');

export const GetRepresentativesListingSchema = z
    .object({
        getObjectFolder: z.object({
            children: z
                .array(z.unknown())
                .transform((representatives) =>
                    transformAndFilterValidItems(RepresentativeSchema, representatives)
                ),
        }),
    })
    .describe('GetRepresentativesListingSchema');
